import React from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { API } from 'aws-amplify';
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle } from 'react-icons/fa';

import Coordinates from '../FormComponents/Coordinates'
import OnSiteFile from '../SCICHEM/FormComponents/OnSiteFile'
import Pollutants from '../SCICHEM/FormComponents/Pollutants'
import TimeOption from '../SCICHEM/FormComponents/TimeOption'
import BuildStacks from '../FormComponents/BuildStacks'
import FileSelect from '../FormComponents/FileSelect'
import FileUpload from '../FormComponents/FileUpload'
import SingleSwitch from '../FormComponents/SingleSwitch'
import MapContainer from '../FormComponents/MapContainer'
import AdvancedForm from './AdvancedOptions/AdvancedForm'
import DropDown from "../FormComponents/DropDown"
import STACK_CONFIG from './config/BuildStack.json'
import MetStationMap from '../FormComponents/MetStationMap'
import DomainOption from '../SCICHEM/FormComponents/DomainOption'
import TextOption from '../FormComponents/TextOption'
import JobIds from '../FormComponents/JobIds'

import { styles, translateRequestBody, validateRequestBody, stackInit, advancedOptions } from './util'

const d = new Date()

class SCICHEMForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            model: "SCICHEM",
            runOption: 'default',
            timeOption: 'SL',
            timeZone: '+5',
            sdate: '',
            edate:"",
            runHours:null,
            runYear:"",
            latitude: null,
            longitude : null,
            stateACRONYM: '',
            dEW:10,
            dNS:10,
            useCTM:true,
            spacing:100,
            dHeight:2500,
            pollutant:"",
            source: {
                1 : stackInit['source']
            },
            scichemStackSourceLocationFile: '',
            fenceLineLocationFile: '',
            buildingLocationFile: '',
            onsiteMeteorologicalDataFile: '',
            osLat:'',
            osLon:'',
            osElev:'',
            hourlyEmissionsDataFile:null,
            wrfAndMMIF: false,
            buildingGeojson: null,
            fencelineGeojson: null,
            drawnBuildings: [],
            drawnFencelines: [],
            sensitiveRecCheck: false,
            useDefaultMetCheck: false,
            selectedSurfaceStation: '{"name":"today"}',
            selectedUpperAirStation: '{"name":"today"}',
            advancedOptions: advancedOptions,
            modelDescription: '',
            validationError: '',
            requestId: null,
            previousMet: '',
            previousProj: '',
            os_pr_type:''

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleStackInputChange = this.handleStackInputChange.bind(this);
        this.handleLoadProjChange = this.handleLoadProjChange.bind(this);
        this.handleAdvancedOptionsInputChange = this.handleAdvancedOptionsInputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.createStack = this.createStack.bind(this);
        this.removeStack = this.removeStack.bind(this);
        this.classes = this.props.classes;

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    api_post_loadproj(value,name) {
        let request = {
            'projID' : value,
            'type' : name
        }
        let options = {
            body: request,
            headers: {},
            response: true
        }
        console.log(request['type'],request['projID'])

        if (value === "NONE" || value === null){
            if (request['type'] === 'fenceLineLocationFile'){
                this.setState({
                    fencelineGeojson : null ,
                    drawnFencelines : []
                })
            } else if (request['type'] === 'buildingLocationFile'){
                this.setState({
                    buildingGeojson : null ,
                    drawnBuildings : []
                })
            } else if (request['type'] === 'scichemStackSourceLocationFile'){
                this.setState({
                    source: {
                        1 : stackInit['source']
                    }
                })
            }

        }else {

            if (request['type'] === 'previousProj'){
                this.setState({
                    buildingGeojson : null ,
                    drawnBuildings : [],
                    fencelineGeojson : null ,
                    drawnFencelines : []
                })
                API.post("AQcast", "/request/loadProj/", options)
                                .then(response => {
                                    this.setState(response.data)
                                    console.log(response.data)
                                    this.api_post_loadproj(this.state.buildingLocationFile,"buildingLocationFile")
                                    this.api_post_loadproj(this.state.fenceLineLocationFile,"fenceLineLocationFile")
                                })
                                .catch(error => {
                                    console.log(error)
                                })
            } else if (request['type'] === 'fenceLineLocationFile' && request['projID'] !== null) {
                if ( request['projID'].includes('Drawn')){
                    API.post("AQcast", "/request/loadProj/", options)
                                    .then(response => {
                                        this.setState({drawnFencelines : response.data})
                                        console.log(response.data)
                                    })
                                    .catch(error => {
                                        console.log(error)
                                    })
                }else if ( request['projID'].includes('Upload')){
                    API.post("AQcast", "/request/loadProj/", options)
                                    .then(response => {
                                        this.setState({fencelineGeojson : response.data})
                                        console.log(response.data)
                                    })
                                    .catch(error => {
                                        console.log(error)
                                    })
                }
            } else if (request['type'] === 'buildingLocationFile' && request['projID'] !== null) {
                if ( request['projID'].includes('Drawn')){
                    API.post("AQcast", "/request/loadProj/", options)
                                    .then(response => {
                                        this.setState({drawnBuildings : response.data})
                                        console.log(response.data)
                                    })
                                    .catch(error => {
                                        console.log(error)
                                    })
                }else if ( request['projID'].includes('Upload')){
                    API.post("AQcast", "/request/loadProj/", options)
                                    .then(response => {
                                        this.setState({buildingGeojson : response.data})
                                        console.log(response.data)
                                    })
                                    .catch(error => {
                                        console.log(error)
                                    })
                }
            } else if (request['type'] === 'scichemStackSourceLocationFile' && request['projID'] !== null) {
                API.post("AQcast", "/request/loadProj/", options)
                                .then(response => {
                                    this.setState({source : response.data.source})
                                    console.log(response.data)
                                })
                                .catch(error => {
                                    console.log(error)
                                })
            }
        }
    }

    /*
    componentDidUpdate(prevProps, prevState) {
        if (this.state.buildingLocationFile){
                this.api_post_loadproj(this.state.buildingLocationFile,"buildingLocationFile")
                this.setState({
                    buildingLocationFile: ''
                })
        }
        //makes loading pev proj trigger load geojson
        if (this.state.fenceLineLocationFile){
                this.api_post_loadproj(this.state.fenceLineLocationFile,"fenceLineLocationFile")
                this.setState({
                    fenceLineLocationFile: ''
                })
        }
    }
    */
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.type === 'radio' ? target.attributes.radioname.value : target.name;
        this.setState({
            [name]: value
        });

        if ( name === 'selectedSurfaceStation'){
            console.log(name,value,JSON.parse(this.state.selectedSurfaceStation).name)
        }

        //battery fire domain size
        if ( name === 'runOption' && value === 'battery' ){
            this.setState({
                ['spacing']: 100,
                ['timeOption']: 'Year',
                ['dNS']: 5,
                ['dEW']:5, 
                ['pollutant']: 'SO2',
                advancedOptions: {
                    ...this.state.advancedOptions,
                    ['gas_deposition']: 0.03,
                    ['battery_species_HFHCL']: true,
                },
                source: {
                    1 : stackInit['source']
                }
            }); 

        }else if ( name === 'runOption' && value !== 'battery' ){
            //change back to defaults
            this.setState({
                ['spacing']: 100,
                ['dNS']: 10,
                ['dEW']:10, 
                ['pollutant']: '',
                advancedOptions: {
                ...this.state.advancedOptions,
                ['gas_deposition']: 0,
                ['density']: 1.2
            }
            });   
        }
    }

    handleLoadProjChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        console.log(value,name)
        this.setState({
            [name]: value
        });

        this.api_post_loadproj(value,name)
    }

    handleStackInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        const id = target.id;
        const stacktype = target.attributes.stacktype.value;

        this.setState({
            [stacktype]: {
                ...this.state[stacktype],
                [id]: {
                    ...this.state[stacktype][id],
                    [name]: value
                }
            }
        });
    }

    handleAdvancedOptionsInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.type === 'radio' ? target.attributes.radioname.value : target.name;

        this.setState({
            advancedOptions: {
                ...this.state.advancedOptions,
                [name]: value
            }
        });
    }

    createStack(stacktype){
        // The new id will be the current max id + 1
        const id = Math.max.apply(null, Object.keys(this.state[stacktype]).map(Number)) + 1;

        this.setState({
            [stacktype]: {
                ...this.state[stacktype],
                [id]: stackInit[stacktype]
            }
        });
    }

    removeStack(stacktype){
        // The id we will be removing is the current max id
        const id = Math.max.apply(null, Object.keys(this.state[stacktype]).map(Number));

        if (id > 1) {
            // Remove the object from the stack
            let stacktypeObject = this.state[stacktype]
            delete stacktypeObject[id]

            this.setState({
                [stacktype]: stacktypeObject
            });
        }
    }

    api_post_SCICHEM(request) {
        let options = {
            body: request,
            headers: {},
            response: true
        }

        this.setState({requestId: 'Loading'});

        API.post("AQcast", "/request/scichem/", options)
            .then(response => {
                this._isMounted && this.setState({requestId: response.data.requestId});
            })
            .catch(error => {
                this._isMounted && this.setState({requestId: 'Error'});
                console.log(error)
            })
    }

    handleSubmit(event) {
        event.preventDefault()
        // Check if the user has left any necessary fields blank
        const errorString = validateRequestBody(this.state)
        if (errorString) {
            this.setState({
                validationError: errorString
            })
            // alert(errorString);
        } else {    // Submit normally
            this.setState({
                validationError: errorString
            })

            const requestBody = translateRequestBody(this.state)
            this._isMounted && this.api_post_SCICHEM(requestBody)
        }
        event.preventDefault();
    }

    displayJobResultLink(){
        if (this.state.requestId === null){
            return null
        } else if (this.state.requestId === "need_tokens") {
            return (
                <b style={{color: 'red'}}>
                    Meteorological Allowances = 0  (purchase more or use met from previous run.)
                </b>
            )
        } else if (this.state.requestId ==='Error') {
            return (
                <b style={{color: 'red'}}>
                    Error submitting job
                </b>
            )
        } else if (this.state.requestId ==='Loading') {
            return (
                <span >
                    Submitting Job...
                </span>
            )
        } else {
            return (
                <span>
                    <Button
                        className={classNames(this.props.margin)}
                        variant="text"
                        color="default"
                        component={Link}
                        target="_blank"
                        to={{
                            pathname: '/SCICHEM/Results',
                            search: '?requestId=' + this.state.requestId
                        }}
                    > Click here to view results of job: {this.state.requestId} </Button>
                    <div><i>Your run has been submitted.  You will receive an email when the project has finished.</i></div>
                    <div><i>In the meantime, you may navigate to other pages or logout of AQcast.</i></div>
                </span>
            )
        }
    }

    render() {

        return (
            <form onSubmit={this.handleSubmit} >
                <div> <b>SCICHEM Version 3.3</b></div>
                <br></br>
                <div>
                    <b>Load Previously Run Project (Optional)<FaInfoCircle data-tip data-for='previousProj'/> </b>

                    <ReactTooltip id='previousProj' place="right" type="light" effect="solid">
                        Loading a previously run project will overwrite any inputs below.
                    </ReactTooltip>
                </div>
                <JobIds
                    classes={this.classes}
                    handleInputChange={this.handleLoadProjChange}
                    value={this.state.previousProj}
                    title='Select a Project description from previous job to load'
                    name='previousProj'
                    model='SCICHEM'
                />

                <div><b> - OR - </b></div>

                <TextOption
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Project Description:'
                    name='modelDescription'
                    maxLength='48'
                    placeholder="Ex: Boston NO2 MMIF 2019-01-03"
                    width='250px'
                    value={this.state.modelDescription}
                    tooltip={[<div key='modelDescription'>A short description for this model (reference only). Max Length: 48 characters, (Spaces, hyphens, and underscores only.)</div>]}
                />

                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Run Option:'
                    name='runOption'
                    value={this.state.runOption}
                    dropdownOptions={
                        [{
                            value: "default",
                            label: "Default"
                        },{
                            value: "setup",
                            label: "Setup Only"
                        },{
                            value: "met",
                            label: "Meteorology Only"
                        },{
                            value: "battery",
                            label: "Battery Fire Simulation"
                        }]
                    }
                    tooltip={[<div key='runOption0'><b>Default:</b> Runs all and does a SIL comparison and basic design values.<br></br>
                            <b>Setup Only:</b> Runs pre-processors and SCICHEM setup, but doesn't run SCICHEM.<br></br>
                            <b>Meteorology Only:</b> Processes meteorology only.<br></br>
                            <b>Battery Fire Simulation":</b> Specialized simulation for BESS battery fires.</div>]}
                />

                <TimeOption
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    timeOption={this.state.timeOption}
                    sdate={this.state.sdate}
                    edate={this.state.edate}
                    runHours={this.state.runHours}
                    runYear={this.state.runYear}/>

                <DropDown
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Time Zone:'
                    name='timeZone'
                    value={this.state.timeZone}
                    dropdownOptions={
                        [{
                            value: "+5",
                            label: "Eastern: New York (UTC-5)"
                        }, {
                            value: "+6",
                            label: "Central: Chicago (UTC-6)"
                        }, {
                            value: "+7",
                            label: "Mountain: Denver (UTC-7)"
                        }, {
                            value: "+8",
                            label: "Pacific: Los Angeles (UTC-8)"
                        }, {
                            value: "+9",
                            label: "Anchorage (UTC-9)"
                        }]
                    }
                    tooltip={[<div key='timeZone0'>Local time zone at your facility.</div>]}
                />

                <Coordinates
                    classes={this.classes}
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    handleInputChange={this.handleInputChange} />

                <DomainOption
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    dEW={this.state.dEW}
                    dNS={this.state.dNS}
                    spacing={this.state.spacing}
                    dHeight={this.state.dHeight}/>

                <SingleSwitch
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Process background data (optional)'
                    label='Use CTM2SCICHEM'
                    name='useCTM'
                    value={this.state.useCTM}
                    tooltip={[<div key='useCTM'>Processes EPA 3D CMAQ data for 2016 and uses as background data.</div>]}
                />

                <Pollutants
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    pollutant={this.state.pollutant}
                />

                <BuildStacks
                    classes={this.classes}
                    handleInputChange={this.handleStackInputChange}
                    stack_config={STACK_CONFIG}
                    createStack={this.createStack}
                    removeStack={this.removeStack}
                    stackIDs={Object.keys(this.state.source)}
                    stack={this.state.source}
                    title='Create New Source (required unless selecting "Meteorology Only" run option)'
                    stackType='source'
                    showStackSeperation='true'
                    required='true'
                    tooltip= 'Source Type: P for "Point" or A for "Area" are accepted for continuous sources. Only necessary parameters need be included per labels below such as (a) for area sources only.'/>

                <div><b style={{padding:'60px'}}>OR</b></div>
                <div className="form-input-container" style={{'height': '100px'}}>
                    <div style={{'width': '450px', 'float': 'left'}}>
                        <FileSelect
                            classes={this.classes}
                            handleInputChange={this.handleLoadProjChange}
                            value={this.state.scichemStackSourceLocationFile}
                            title='Select Previously Created Source Parameter File'
                            name='scichemStackSourceLocationFile'
                            tooltip={[<div key='stackSourceLocationFile0'>Will load a previously created source emissions/parameter file into above source tables for editing.</div>]}
                        />
                    </div>
                    <div style={{'width': '450px', 'float': 'left'}}>
                        <FileUpload
                            classes={this.classes}
                            handleInputChange={this.handleInputChange}
                            value={this.state.hourlyEmissionsDataFile}
                            title='Hourly Emissions'
                            name='hourlyEmissionsDataFile'
                            tooltip={[<div key='hourlyEmissionsDataFile'>Format must be correct. See User Guide for details</div>]}
                        />
                    </div>
                </div>

                <div className="form-input-container">
                    <b> Draw/Upload buildings and fencelines on the map: (optional)</b>
                </div>
                <MapContainer
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    source={this.state.source}
                    buildingGeojson={this.state.buildingGeojson}
                    fencelineGeojson={this.state.fencelineGeojson}
                    drawnBuildings={this.state.drawnBuildings}
                    drawnFencelines={this.state.drawnFencelines}
                    fenceLineLocationFile={this.state.fenceLineLocationFile}
                    buildingLocationFile={this.state.buildingLocationFile}
                    previousProj={this.state.previousProj}
                />

                <div className="form-input-container" style={{'height': '100px'}}>
                    <div style={{'width': '350px', 'float': 'left'}}>
                        <FileSelect
                            classes={this.classes}
                            handleInputChange={this.handleLoadProjChange}
                            value={this.state.fenceLineLocationFile}
                            title='Previously Created Fence Line File'
                            name='fenceLineLocationFile'
                            tooltip={[<div key='fenceLineLocationFile0'><b>Not required.</b> Previously created fenceline file shown in list, or upload *.shp.zip or draw it above.</div>]}
                        />
                    </div>
                    <div style={{'width': '350px', 'float': 'left'}}>
                        <FileSelect
                            classes={this.classes}
                            handleInputChange={this.handleLoadProjChange}
                            value={this.state.buildingLocationFile}
                            title='Previously Created Building File'
                            name='buildingLocationFile'
                            tooltip={[<div key='buildingLocationFile'><b>Not required.</b> Previously created buildings file shown in list, or upload *.shp.zip or draw it above.</div>]}
                        />
                    </div>
                </div>

                <SingleSwitch
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    title='Sensitive Receptors (optional)'
                    label='Find and include sensitive receptors in the model output.'
                    name='sensitiveRecCheck'
                    value={this.state.sensitiveRecCheck}
                    tooltip={[<div key='sensitiveRecCheck'>Sensitive receptors such as churches, schools, and hospitals will be included in the results.</div>]}
                />
                <div><h2>Choose 1 meteorology source:</h2></div>
                <i><p>The priority of meteorology data options are as follows: previous meteorology option, onsite meteorology,
                default stations, selected stations via the map.</p></i>

                <FileUpload
                    classes={this.classes}
                    handleInputChange={this.handleInputChange}
                    value={this.state.onsiteMeteorologicalDataFile}
                    title='OnSite Surface Meteorological'
                    name='onsiteMeteorologicalDataFile'
                    tooltip={[<div key='onsiteMeteorologicalDataFile'>Format must be correct. See User Guide for details. <b>Note: Selected Upper Air Station data will also be used, as ONSITE data is in place of a NOAA surface station.</b></div>]}
                />

                <OnSiteFile
                    classes={this.classes}
                    osLat={this.state.osLat}
                    osLon={this.state.osLon}
                    osElev={this.state.osElev}
                    os_pr_type={this.state.os_pr_type}
                    handleInputChange={this.handleInputChange} />

                <MetStationMap
                    classes={this.classes}
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    selectedSurfaceStation={this.state.selectedSurfaceStation}
                    selectedUpperAirStation={this.state.selectedUpperAirStation}
                    useDefaultMetCheck={this.state.useDefaultMetCheck}
                    model='SCICHEM'
                    previousMet={this.state.previousMet}
                    handleInputChange={this.handleInputChange}
                />

                <AdvancedForm
                    classes={this.classes}
                    handleInputChange={this.handleAdvancedOptionsInputChange}
                    advancedOptions={this.state.advancedOptions}
                />

                <Button
                    className={classNames(this.classes.margin, this.classes.textField)}
                    type="submit"
                    variant="contained"
                    color="primary"> Submit
                </Button>
                {this.displayJobResultLink()}
                <b style={{color:'red'}}>{this.state.validationError}</b>

            </form>
        )}
}


SCICHEMForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SCICHEMForm);
